import { Card } from "@acme/ui/card";
import { useQuery } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import { BarChart3, Heart } from "lucide-react";
import { useTranslation } from "react-i18next";
import { api } from "~/common/utils/trpc.js";

export const Route = createFileRoute("/_authed/my-players/$tag/")({
  component: DashboardTab,
});

function DashboardTab() {
  const { t } = useTranslation();
  const { tag } = Route.useParams();

  const overviewQueryOptions = api.player.getOverviewItemByTag.queryOptions(
    { playerTag: tag },
    { enabled: tag.length > 0 }
  );
  const { data: overview } = useQuery(overviewQueryOptions);

  if (overview == null) return null;

  return (
    <div className="grid gap-4 sm:grid-cols-2 lg:grid-cols-3">
      <Card className="p-4">
        <div className="flex items-center gap-2 text-muted-foreground">
          <BarChart3 className="size-4" />
          <span className="text-sm font-medium">{t("app.placeholders.playerDashboardStats")}</span>
        </div>
        <p className="mt-2 text-xs text-muted-foreground">{t("app.placeholders.playerDashboardStatsHint")}</p>
      </Card>
      <Card className="p-4 sm:col-span-2 lg:col-span-1">
        <div className="flex items-center gap-2 text-muted-foreground">
          <Heart className="size-4" />
          <span className="text-sm font-medium">{t("app.placeholders.communityRating")}</span>
        </div>
        <div className="mt-2 flex items-baseline gap-2">
          <span className="text-2xl font-bold tabular-nums">0</span>
          <span className="text-xs text-muted-foreground">{t("app.placeholders.communityRatingScale")}</span>
        </div>
        <p className="mt-1 text-xs text-muted-foreground">{t("app.placeholders.communityRatingHint")}</p>
      </Card>
    </div>
  );
}
